import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e656498"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mb-4 gx-3 gy-md-3 gy-2" }
const _hoisted_2 = { class: "col-md-7" }
const _hoisted_3 = { class: "col-md-5 d-flex align-items-end justify-content-end" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "person-list-item__title" }
const _hoisted_6 = { class: "person-list-item__price-group" }
const _hoisted_7 = {
  key: 0,
  class: "text-success strong d-block d-md-inline-block"
}
const _hoisted_8 = { class: "person-list-item__price-group-label ms-md-1" }
const _hoisted_9 = {
  key: 1,
  class: "text-price-before ms-1"
}
const _hoisted_10 = { class: "ms-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn-popover btn-popover bg-success" }, "%", -1))
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-delete",
  "aria-label": "Delete Person"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "row person-list__total-wrapper" }
const _hoisted_16 = { class: "col text-end" }
const _hoisted_17 = { class: "person-list__total-label" }
const _hoisted_18 = { class: "person-list__total" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Select, {
          label: _ctx.translate('Shop.ticket-config.choose-person'),
          id: "persons",
          name: "persons",
          placeholder: _ctx.translate('Shop.ticket-config.choose-person'),
          modelValue: _ctx.personForm.selectedPerson,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.personForm.selectedPerson) = $event)),
          options: _ctx.personOptions
        }, null, 8, ["label", "placeholder", "modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn btn-dark btn-form-height w-100 px-2",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onAddPerson && _ctx.onAddPerson(...args))),
          disabled: _ctx.personForm.selectedPerson === '' || !_ctx.availablePersons
        }, " + " + _toDisplayString(_ctx.translate('shop.configuration.add-person')), 9, _hoisted_4)
      ])
    ]),
    _createVNode(_TransitionGroup, {
      name: "list",
      tag: "ul",
      class: "vertical-gutter gy-2 list-unstyled person-list"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ticketPersons.value, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "person-list-item vertical-gutter__item",
            key: item
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1),
            _createElementVNode("span", _hoisted_6, [
              (_ctx.pricePerPriceGroup(item.priceGroup).priceGroupInfo)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.pricePerPriceGroup(item.priceGroup).priceGroupInfo), 1))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.translate('shop.configuration.price')), 1),
              (_ctx.pricePerPriceGroup(item.priceGroup).priceBeforeDiscount)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.convertInCurrency(_ctx.pricePerPriceGroup(item.priceGroup).priceBeforeDiscount, _ctx.selectedCurrency)), 1))
                : _createCommentVNode("", true),
              _createElementVNode("strong", _hoisted_10, _toDisplayString(_ctx.convertInCurrency(_ctx.pricePerPriceGroup(item.priceGroup).price, _ctx.selectedCurrency)), 1),
              (_ctx.pricePerPriceGroup(item.priceGroup).priceDiscountInfo)
                ? (_openBlock(), _createBlock(_component_Popper, { key: 2 }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", null, _toDisplayString(_ctx.pricePerPriceGroup(item.priceGroup).priceDiscountInfo), 1)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              class: "person-list-item__delete",
              onClick: ($event: any) => (_ctx.onRemovePerson(item.value))
            }, _hoisted_14, 8, _hoisted_12)
          ]))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.translate('shop.configuration.total-price')), 1),
        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.convertInCurrency(_ctx.getTotal(), _ctx.selectedCurrency)), 1)
      ])
    ])
  ], 64))
}